import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify'
import { UserPreRedirectLoginService } from './services/user-pre-redirect-login';
import { UserPreRedirectLoginServiceImpl } from './services/impls/user-pre-redirect-login';

export const userPreRedirectLoginModule = new ContainerModule((bind) => {
    bind(UserPreRedirectLoginService).to(UserPreRedirectLoginServiceImpl);
});
